var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 1.42188L6.39844 5.71094C6.25781 5.82812 6.11719 5.875 6 5.875C5.85938 5.875 5.71875 5.82812 5.60156 5.73438L1.10156 1.42188C0.867188 1.21094 0.867188 0.835938 1.07812 0.625C1.28906 0.390625 1.66406 0.390625 1.875 0.601562L6 4.53906L10.1016 0.601562C10.3125 0.390625 10.6875 0.390625 10.8984 0.625C11.1094 0.835938 11.1094 1.21094 10.875 1.42188Z",
    fill: "#2E3844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7d496954d498c4a729f431c2e71cbb3f.svg";
export { ForwardRef as ReactComponent };